module.exports = {
        srcSet: __webpack_public_path__ + "amenities_returns-920-be427cfb01f35a82.digested.jpg"+" 920w",
        images: [{path: __webpack_public_path__ + "amenities_returns-920-be427cfb01f35a82.digested.jpg",width: 920,height: 520}],
        src: __webpack_public_path__ + "amenities_returns-920-be427cfb01f35a82.digested.jpg",
        toString: function(){return __webpack_public_path__ + "amenities_returns-920-be427cfb01f35a82.digested.jpg"},
        
        width: 920,
        height: 520
      }